module.exports = __webpack_public_path__ + "img/planck.2e550d8f.svg";